import { render } from "./CreatePassword.vue?vue&type=template&id=354bdb9b&scoped=true"
import script from "./CreatePassword.vue?vue&type=script&lang=js"
export * from "./CreatePassword.vue?vue&type=script&lang=js"

import "./CreatePassword.vue?vue&type=style&index=0&id=354bdb9b&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354bdb9b"]])

export default __exports__